class UnauthorizedError extends Error {
  constructor(...args) {
    super(...args);
    this.statusCode = 401;
  };
};
export default UnauthorizedError;